/**
 * @generated SignedSource<<0a3e597c5c81e9255604bf0649e95850>>
 * @relayHash 74f7600e51ceb43caf63d5d0a0e8fb2e
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 74f7600e51ceb43caf63d5d0a0e8fb2e

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "PropositionResponse",
    "kind": "LinkedField",
    "name": "resumeProposition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResumePropositionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResumePropositionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "74f7600e51ceb43caf63d5d0a0e8fb2e",
    "metadata": {},
    "name": "ResumePropositionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "129a9a08cb3a7483ec41cf8bfe4b57c7";

export default node;
